/* eslint-disable import/prefer-default-export */
import { overDue } from '../../constants/textConstants';
import urlTags from '../../serverConfig/microService';
import { Types } from '../request';
import ApiTag from './apiTags';

export const BASE = '/base'; // /common
export const CSR = '/communication'; //microservice
export const AUTH = '/authentication'; //microservice
export const CALL_ON_CLOSE_OVEDUE = '/overdue'
export const OVERDUE = '/overdue'; //microservice
export const BANK = '/bankmgmt'; //microservice
export const SOURCE = '/sourceTracker'; //microservice
export const CREDIT = '/creditcardmgmt'; //microservice
export const DEBIT = '/debitCard'; //microservice
export const PROFILE = '/profilemgmt'; //microservice
export const NLI = '/nli'; //microservice
export const LOAN = '/loanmgmt'; //microservice
export const REKYC = '/rekyc';
export const M2M = '/nli/m2m';
export const PEBBLE = '/pebble';
export const TIO = '/conversion';
export const BANKMGT = '/bankmgmt';
export const INVSTMENT = '/investment';
export const GRAVITY = '/integrationmgmt';
export const PINDETAILS = '/profilemgmt';
export const CONVERSION = '/conversion';
export const dataGovernance = '/dataGovernance'; // data governance microservice
export const DualResidency = '/dualresidency'; // dual residency microservice
export const DATAQUALITY = '/data-quality-ovd' //data quality microservice
export const KYC_BUTTON = '/kycb' // kyc button
export const IMOBILE = '/imobileservice' // imobile
export const DIGILOCKER = '/digilocker'; // microservice

export const JwtToken = (payload, service = '') => {
  return {
    url: service + urlTags.GENERATE_JWT_TOKEN,
    payload,
    type: Types.GET,
    tag: ApiTag.GENERATE_JWT_TOKEN,
    headers: {},
    authRequired: false,
  };
};
export const EmailId = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATE_EMAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATE_EMAIL,
    headers: {},
    authRequired: true,
  };
};

export const ValidateSrNumber = (payload, service = "") => {
  return {
    url: service + urlTags.VALIDATESR,
    payload,
    type: Types.POST,
    tag: ApiTag.VALIDATESR_TAG,
    headers: {},
    authRequired: true,
  };
};

export const callDiscrepantSuccessAPI = (payload, service = "") => {
  return {
    url: service + urlTags.DISCREPANT_SUCCESS,
    payload,
    type: Types.POST,
    tag: ApiTag.DISCREPANT_SUCCESS_TAG,
    headers: {},
    authRequired: true,
  };
};

export const userNameUpdate = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATE_USERNAME,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATE_USERNAME,
    headers: {},
    authRequired: true,
  };
};

export const submitFinalApiDual = (payload, service= '')=>{
  return {
    url: service + urlTags.SUBMITCUSTOMERDET,
    payload,
    type: Types.POST,
    tag: ApiTag.SUBMITCUSTOMER_DUALTAG,
    headers: {},
    authRequired: true,
  }
}

//dual residency api
export const getDecrypetedDataDual = (payload, service= '')=>{
  return {
    url: service + urlTags.GETDECRYPTEDDATADUAL,
    payload,
    type: Types.POST,
    tag: ApiTag.GETDECRYPTEDDATA_DUALTAG,
    headers: {},
    authRequired: true,
  }
}

export const otpMobileGenerate = (payload, service = '') => {
  return {
    url: service + urlTags.GENERATE_MOBILE_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.GENERATE_MOBILE_OTP,
    headers: {},
    authRequired: true,
  };
};

export const verifyMobileOtp = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFY_MOBILE_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFY_MOBILE_OTP,
    headers: {},
    authRequired: true,
  };
};
export const verifyAadharOtp = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFY_AADHAR_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFY_AADHAR_OTP,
    headers: {},
    authRequired: true,
  };
};
export const  gridAuthenticationCSP = (payload, service= '')=>{
  return {
    url: service + urlTags.GRIDAUTHENTICATIONCSP,
    payload,
    type: Types.POST,
    tag: ApiTag.GRIDAUTHENTICATIONCSP,
    headers: {},
    authRequired: true,
  }
}
export const userVerification = (payload, service = '') => {
  return {
    url: service + urlTags.USER_VERIFICATION,
    payload,
    type: Types.POST,
    tag: ApiTag.USER_VERIFY,
    headers: {},
    authRequired: true,
  };
};
export const getGoogleLocation = (payload, service = '') => {
  return {
    url: service + urlTags.GETGOOGLELOC,
    payload,
    type: Types.POST,
    tag: ApiTag.GETGOOGLELOC,
    headers: {},
    authRequired: true,
  };
};
export const GENERATEAADAHR = (payload, service = '') => {
  return {
    url: service + urlTags.GENERATEAADAHR,
    payload,
    type: Types.POST,
    tag: ApiTag.GENERATEAADHAR,
    headers: {},
    authRequired: true,
  };
};
export const VerifyPan = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYPAN,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYPAN,
    headers: {},
    authRequired: true,
  };
};
export const ConvertTransactionToEMI = (payload, service = '') => {
  return {
    url: service + urlTags.GETCREDITDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCREDITDETAILS,
    headers: {},
    authRequired: true,
  };
};

export const updatePAN = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATE_PAN,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATE_PAN,
    headers: {},
    authRequired: true,
  };
};
export const getService = (payload, service = '') => {
  return {
    url: service + urlTags.GETSERVICE,
    payload,
    type: Types.POST,
    tag: ApiTag.GETSERVICE,
    headers: {},
    authRequired: false,
  };
};
export const gettestApi = (payload, service = '') => {
  return {
    url: service + urlTags.testApi,
    payload,
    type: Types.POST,
    tag: ApiTag.GETSERVICE,
    headers: {},
    authRequired: false,
  };
};

export const MenuOption = (payload, service = '') => {
  return {
    url: service + urlTags.Menu_Option,
    payload,
    type: Types.GET,
    tag: ApiTag.Menu_Option,
    headers: {},
    authRequired: false,
  };
};

export const UpdateAddress = (payload, service = '') => {
  return {
    url: service + urlTags.Update_Address,
    payload,
    type: Types.POST,
    tag: ApiTag.Update_Address,
    headers: {},
    authRequired: true,
  };
};
export const UpdateService = (payload, service = '') => {
  return {
    url: service + urlTags.UpdateService,
    payload,
    type: Types.POST,
    tag: ApiTag.UpdateService,
    headers: {},
    authRequired: true,
  };
};

export const dynamicField = (payload, service = '') => {
  return {
    url: service + urlTags.GETDYNAMICFIELD,
    payload,
    type: Types.POST,
    tag: ApiTag.GETDYNAMICFIELD,
    headers: {},
    authRequired: true,
  };
};

export const blockCreditDebitCheque = (payload, service = '') => {
  return {
    url: service + urlTags.block_cheque_credit,
    payload,
    type: Types.POST,
    tag: ApiTag.block_cheque_credit,
    headers: {},
    authRequired: true,
  };
};

export const getCancelMandate = (payload, service = '') => {
  return {
    url: service + urlTags.GET_CANCELMANDATE,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_CANCELMANDATE,
    headers: {},
    authRequired: true,
  };
};

export const OverdueMenuOption = (payload, service = '') => {
  return {
    url: service + urlTags.Overdue_Menu_Option,
    payload,
    type: Types.GET,
    tag: ApiTag.Overdue_Menu_Option,
    headers: {},
    authRequired: false,
  };
};

export const termsNdCondition = (payload, service = '') => {
  return {
    url: service + urlTags.terms_condition,
    payload,
    type: Types.POST,
    tag: ApiTag.terms_condition,
    headers: {},
    authRequired: true,
  };
};

export const getOverdueDetails = (payload, service = '') => {
  return {
    url: service + urlTags.get_overdue_details,
    payload,
    type: Types.POST,
    tag: ApiTag.get_overdue_details,
    headers: {},
    authRequired: true,
  };
};
export const getQuickPayDetails = (payload, service = '') => {
  return {
    url: service + urlTags.getQuickPayDetails,
    payload,
    type: Types.POST,
    tag: ApiTag.getQuickPayDetails,
    headers: {},
    authRequired: true,
  };
};
export const getCarAPI = (payload, service = '') => {
  return {
    url: service + urlTags.getCarApi,
    payload,
    type: Types.POST,
    tag: ApiTag.getCarAPI,
    headers: {},
    authRequired: true,
  };
};


export const getPqOfferDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETPQOFFERDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.get_pqOffer_details,
    headers: {},
    authRequired: true,
  };
};
export const getMasterDate = (payload, service = '') => {
  return {
    url: service + urlTags.GETMASTERDATE,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_MASTER_DATE,
    headers: {},
    authRequired: true,
  };
};
export const getEmailOtpCSP = (payload, service = '') => {
  return {
    url: service + urlTags.GET_EMAIL_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_EMAIL_OTP_TAG,
    headers: {},
    authRequired: true,
  };
};

export const EasyPay = (payload, service = '') => {
  return {
    url: service + urlTags.getEasyPay,
    payload,
    type: Types.POST,
    tag: ApiTag.getEasyPay,
    headers: {},
    authRequired: true,
  };
};

export const PaymentStatus = (payload, service = '') => {
  return {
    url: service + urlTags.transactionStatus,
    payload,
    type: Types.GET,
    tag: ApiTag.transactionStatus,
    headers: {},
    authRequired: true,
  };
};

export const pqTrasnactionDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETPQTRANSACTIONDETAILS,
    payload,
    type: Types.GET,
    tag: ApiTag.GETPQTRANSACTIONDETAILS,
    headers: {},
    authRequired: true,
  };
};

export const DeActivateToken = (payload, service = '') => {
  return {
    url: service + urlTags.DEACTIVATE_TOKEN,
    payload,
    type: Types.POST,
    tag: ApiTag.DEACTIVATE_TOKEN,
    headers: {},
    authRequired: true,
  };
};
export const confirmSRDetails = (payload, service = '') => {
  return {
    url: service + urlTags.CONFIRMSRDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.CONFIRMSRDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getSRDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETSRDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETSRDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getConfirmDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETCONFIRMDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCONFIRMDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const smsToCustomer = (payload, service = '') => {
  return {
    url: service + urlTags.SMSTOCUSTOMER,
    payload,
    type: Types.POST,
    tag: ApiTag.SMSTOCUSTOMER,
    headers: {},
    authRequired: true,
  };
};
export const getDecryptedDataGrid = (payload, service = '') => {
  return {
    url: service + urlTags.GET_DECRYPTED_DATA_GRID,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_DECRYPTED_DATA_GRID,
    headers: {},
    authRequired: true,
  }
}
export const getServiceDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETSERVICEDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETSERVICEDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getPincodeDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETPINCODEDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.GETPINCODEDETAIL,
    headers: {},
    authRequired: true,
  };
};
export const getDecrypetedData = (payload, service = '') => {
  return {
    url: service + urlTags.GETDECRYPTEDDATA,
    payload,
    type: Types.POST,
    tag: ApiTag.GETDECRYPTEDDATA,
    headers: {},
    authRequired: true,
  };
};
export const getDecryptedDataCashWithdrawal = (payload, service = '') => {
  return {
    url: service + urlTags.GET_DECRYPTED_CASH_WITHDRAWAL,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_DECRYPTED_CASH_WITHDRAWAL,
    headers: {},
    authRequired: true,
  };
};

export const raiseServiceRequest = (payload, service = '') => {
  return {
    url: service + urlTags.RAISE_SERVICE_REQUEST,
    payload,
    type: Types.POST,
    tag: ApiTag.RAISE_SERVICE_REQUEST,
    headers: {},
    authRequired: true,
  };
};

export const getMobileOtp = (payload, service = '') => {
  return {
    url: service + urlTags.GET_MOBILE_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_MOBILE_OTP,
    headers: {},
    authRequired: true,
  };
};
export const verifyMobOtp = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFY_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFY_OTP,
    headers: {},
    authRequired: true,
  };
};

export const getRekycDecrypetedData = (payload, service = '') => {
  return {
    url: service + urlTags.GETREKYCDECRYPTEDDATA,
    payload,
    type: Types.POST,
    tag: ApiTag.GETREKYCDECRYPTEDDATA,
    headers: {},
    authRequired: true,
  };
};
export const validatedataQualityPAN = (payload, service = '') => {
  return {
    url: service + urlTags.VERYFYPANDGOV,
    payload,
    type: Types.POST,
    tag: ApiTag.VALIDATE_PAN,
    headers: {},
    authRequired: true
  };
};

// export const uploadDocSample = (payload, service = '', uploadCallback) => {
//   return {
//     baseURL: "http://localhost:8080",
//     url: "/upload",
//     payload,
//     type: Types.POST,
//     tag: ApiTag.GETREKYCDECRYPTEDDATA,
//     headers: {"Content-Type": "multipart/form-data"},
//     uploadCallback,
//     authRequired: true,
//   };
// };
export const getDecryptedTestDataService = (payload, service = '') => {
  return {
    url: service + urlTags.GETREKYCDECRYPTEDDATATESTSERVICE,
    payload,
    type: Types.POST,
    tag: ApiTag.GETREKYCDECRYPTEDDATATESTSERVICE,
    headers: {},
    authRequired: true,
  };
};

export const uploadfiles = (payload, service = '') => {
  return {
    url: service + urlTags.UPLOADFILES,
    payload,
    type: Types.POST,
    tag: ApiTag.UPLOADFILES,
    headers: {},
    authRequired: true,
  };
};
export const VerifyAccountNumber = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYACCOUNTNUMBER,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYACCOUNTNUMBER,
    headers: {},
    authRequired: true,
  };
};
export const getOrderDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETORDERDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETORDERDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getCreditDetails = (payload, service = '') => {
  return {
    url: service + urlTags.SAVETRANSACTIONDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.SAVETRANSACTIONDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getPaymentDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETPAYMENTDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETPAYMENTDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getNpcdetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETIINDETAILS,
    payload,
    type: Types.GET,
    tag: ApiTag.GETIINDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getBankNames = (payload, service = '') => {
  return {
    url: service + urlTags.GETBANKDETAILS,
    payload,
    type: Types.GET,
    tag: ApiTag.GETBANKDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getLanguage = (payload, service = '') => {
  return {
    url: service + urlTags.GETLANGAUGE,
    payload,
    type: Types.GET,
    tag: ApiTag.GETLANGAUGE,
    headers: {},
    authRequired: true,
  };
};
export const sendDetails = (payload, service = '') => {
  return {
    url: service + urlTags.SENDDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.SENDDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const VERIFYCREDITCARD = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYCREDIT,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYCREDIT,
    headers: {},
    authRequired: true,
  };
};
export const getDebitDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETDEBITDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETDEBITDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getDebitUserDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETDEBITUSERDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETDEBITUSERDETAILS,
    headers: {},
    authRequired: true,
  };
};

export const getChequeStatus = (payload, service = '') => {
  return {
    url: service + urlTags.GETCHEQUESTATUS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCHEQUESTATUS,
    headers: {},
    authRequired: true,
  };
};

export const getOverdueMenuItem = (payload, service = '') => {
  return {
    url: service + urlTags.GETOVERDUEMENU,
    payload,
    type: Types.GET,
    tag: ApiTag.GETOVERDUEMENU,
    headers: {},
    authRequired: true,
  };
};
export const getBitlyUrl = (payload, service = '') => {
  return {
    url: service + urlTags.GETBITLY,
    payload,
    type: Types.POST,
    tag: ApiTag.GETBITLY,
    headers: {},
    authRequired: false,
  };
};
export const getCibitDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETCIBIL,
    payload,
    type: Types.GET,
    tag: ApiTag.GETCIBIL,
    headers: {},
    authRequired: true,
  };
};
export const sendSMS = (payload, service = '') => {
  return {
    url: service + urlTags.SENDSMS,
    payload,
    type: Types.POST,
    tag: ApiTag.SENDSMS,
    headers: {},
    authRequired: true,
  };
};
export const CONSENTWHATSAPP = (payload, service = '') => {
  return {
    url: service + urlTags.CONSENTWHATSAPP,
    payload,
    type: Types.POST,
    tag: ApiTag.CONSENTWHATSAPP,
    headers: {},
    authRequired: true,
  };
};
export const getCreditNumbers = (payload, service = '') => {
  return {
    url: service + urlTags.GETCREDITACCOUNTS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCREDITACCOUNTS,
    headers: {},
    authRequired: true,
  };
};

export const GETUSERDETAILS = (payload, service = '') => {
  return {
    url: service + urlTags.GETUSERDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETUSERDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const GETPPACODE = (payload, service = '') => {
  return {
    url: service + urlTags.GETPPACODE,
    payload,
    type: Types.GET,
    tag: ApiTag.GETPPACODE,
    headers: {},
    authRequired: true,
  };
};
export const GETSEARCH = (payload, service = '') => {
  return {
    url: service + urlTags.GETSEARCH,
    payload,
    type: Types.POST,
    tag: ApiTag.GETSEARCH,
    headers: {},
    authRequired: true,
  };
};
export const GETFILEDATA = (payload, service = '') => {
  return {
    url: service + urlTags.GETFILEDATA,
    payload,
    type: Types.POST,
    tag: ApiTag.GETFILEDATA,
    headers: {},
    authRequired: true,
  };
};

export const VERIFYDEBITCARD = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYDEBITCARD,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYDEBITCARD,
    headers: {},
    authRequired: true,
  };
};
export const VERIFYAUTODEBITCARD = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYAUTODEBITCARD,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYAUTODEBITCARD,
    headers: {},
    authRequired: true,
  };
};
export const VERIFYCOMMUNICATIONADDRESS = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYCOMMUNICATIONADDRESS,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYCOMMUNICATIONADDRESS,
    headers: {},
    authRequired: true,
  };
};
export const getUserDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETUSERDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.GETUSERDETAIL,
    headers: {},
    authRequired: true,
  };
};
export const GETCITY = (payload, service = '') => {
  return {
    url: service + urlTags.GETCITY,
    payload,
    type: Types.GET,
    tag: ApiTag.GETCITY,
    headers: {},
    authRequired: true,
  };
};
export const GETYEAR = (payload, service = '') => {
  return {
    url: service + urlTags.GETYEAR,
    payload,
    type: Types.GET,
    tag: ApiTag.GETYEAR,
    headers: {},
    authRequired: true,
  };
};
export const GETMFG = (payload, service = '') => {
  return {
    url: service + urlTags.GETMFG,
    payload,
    type: Types.GET,
    tag: ApiTag.GETMFG,
    headers: {},
    authRequired: true,
  };
};
export const GETMODEL = (payload, service = '') => {
  return {
    url: service + urlTags.GETMODEL,
    payload,
    type: Types.POST,
    tag: ApiTag.GETMODEL,
    headers: {},
    authRequired: true,
  };
};
export const GETVARIANT = (payload, service = '') => {
  return {
    url: service + urlTags.GETVARIANT,
    payload,
    type: Types.POST,
    tag: ApiTag.GETVARIANT,
    headers: {},
    authRequired: true,
  };
};
export const VerifyLoanNumber = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYLOANNUMBER,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYLOANNUMBER,
    headers: {},
    authRequired: true,
  };
};
export const VerifyDmatNumber = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYDMATNUMBER,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYDMATNUMBER,
    headers: {},
    authRequired: true,
  };
};
export const GETPRICINGDETAILS = (payload, service = '') => {
  return {
    url: service + urlTags.GETPRICINGDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETPRICINGDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const GETLEADGENERATIONDETAILS = (payload, service = '') => {
  return {
    url: service + urlTags.GETLEADGENERATIONDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETLEADGENERATIONDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getCarDekhoLocationDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETCARDEKHOLOCATIONDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCARDEKHOLOCATIONDETAILS,
    headers: {},
    authRequired: true,
  };
};

export const JwtTokenNLI = (payload, service = '') => {
  return {
    url: service + urlTags.GENERATE_JWT_TOKEN_NLI,
    payload,
    type: Types.GET,
    tag: ApiTag.GENERATE_JWT_TOKEN_NLI,
    headers: {},
    authRequired: false,
  };
};
export const getServiceNLI = (payload, service = '') => {
  return {
    url: service + urlTags.GETSERVICE_NLI,
    payload,
    type: Types.POST,
    tag: ApiTag.GETSERVICE_NLI,
    headers: {},
    authRequired: false,
  };
};
export const getGridCardAccountNumberDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GRIDCARDACCOUNTDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GRIDCARDACCOUNTNUMBER_TAG,
    headers: {},
    authRequired: true,
  };
};
export const getGridCardDebitCardNumberDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GRIDCARDDEBITDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GRIDCARDDEBITCARDNUMBER_TAG,
    headers: {},
    authRequired: true,
  };
};
export const generateVerifyOtp = (payload, service = '') => {
  return {
    url: `${service}/${ApiTag.GENERATE_VERIFY_OTP}`,
    payload,
    type: Types.POST,
    tag: ApiTag.GENERATE_VERIFY_OTP,
    headers: {},
    authRequired: true,
  };
};


export const getDropdownList = (payload, service = '') => {
  return {
    url: service + urlTags.GETDROPDOWNLIST,
    payload,
    type: Types.POST,
    tag: ApiTag.GETDROPDOWNLIST,
    headers: {},
    authRequired: true,
  };
};
export const submitGrievanceOne = (payload, service = '') => {
  return {
    url: service + urlTags.SUBMITGRIEVANCEFORM,
    payload,
    type: Types.POST,
    tag: ApiTag.SUBMITFORMGRIEVANCE,
    headers: {},
    authRequired: true
  };
};
export const deactivateNliToken = (payload, service = '') => {
  return {
    url: service + urlTags.DEACTIVATE_TOKEN_NLI,
    payload,
    type: Types.POST,
    tag: ApiTag.DEACTIVATE_TOKEN_NLI,
    headers: {},
    authRequired: true
  };
};
export const grievanceSearch = (payload, service = '') => {
  return {
    url: service + urlTags.GRIEVANCESEARCH,
    payload,
    type: Types.POST,
    tag: ApiTag.GRIEVANCE_SEARCH,
    headers: {},
    authRequired: true
  };
};
export const pinCode = (payload, service = '') => {
  return {
    url: service + urlTags.PINCODE,
    payload,
    type: Types.POST,
    tag: ApiTag.PINCODE,
    headers: {},
    authRequired: true
  };
};
export const getForexReqDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETFOREXDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.GETFOREXDETAILTAG,
    headers: {},
    authRequired: true
  };
};

export const getHomePropertyDetail = (payload, service = '') => {
  return {
    url: service + urlTags.GETHOMEPROPERTYDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.GETHOMEPROPERTYDETAILTAG,
    headers: {},
    authRequired: true
  };
};
export const getLoanQrDetails = (payload, service= '')=>{
  return {
    url: service + urlTags.GETLOANQRDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETLOANQRDETAILS_TAG,
    headers: {},
    authRequired: true,
  }
}

// REKYC
export const deactivateRekycToken = (payload, service = '') => {
  return {
    url: service + urlTags.DEACTIVATE_REKYC_TOKEN,
    payload,
    type: Types.GET,
    tag: ApiTag.DEACTIVATE_REKYC_TOKEN,
    headers: {},
    authRequired: true,
  };
};

export const refreshToken = (payload, service = '') => {
  return {
    url: service + urlTags.REFRESH_REKYC_TOKEN,
    payload,
    type: Types.GET,
    tag: ApiTag.REFRESH_REKYC_TOKEN,
    headers: {},
    authRequired: true,
  };
};

export const getMasterData = (payload, service = '') => {
  return {
    url: service + urlTags.GETMASTERDATA,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_MASTER_DATA,
    headers: {},
    authRequired: true
  };
};
export const getAllMasterData = (payload, service = '') => {
  return {
    url: service + urlTags.GETALLMASTERDATA,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_ALL_MASTER_DATA,
    headers: {},
    authRequired: true
  };
};

export const getAccountEmail = (payload, service = '') => {
  return {
    url: service + urlTags.GETACCOUNTEMAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_ACCOUNT_EMAIL,
    headers: {},
    authRequired: true
  };
};
export const getUpdatedEmail = (payload, service = '') => {
  return {
    url: service + urlTags.GETUPDATEDEMAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_UPDATED_EMAIL,
    headers: {},
    authRequired: true
  };
};

export const getEmailOtp = (payload, service = '') => {
  return {
    url: service + urlTags.GETEMAILOTP,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_EMAIL_OTP,
    headers: {},
    authRequired: true
  };
};
export const verifyEmailOtp = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYEMAILOTP,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFY_EMAIL_OTP,
    headers: {},
    authRequired: true
  };
};

export const verifyEmailOtpNLI = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFY_EMAIL_OTP_NLI,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFY_EMAIL_OTP,
    headers: {},
    authRequired: true
  };
};
export const updateRekycPAN = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATEREKYCPAN,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATE_PAN,
    headers: {},
    authRequired: true
  };
};
export const validateRekycPAN = (payload, service = '') => {
  return {
    url: service + urlTags.VALIDATEREKYCPAN,
    payload,
    type: Types.POST,
    tag: ApiTag.VALIDATE_PAN,
    headers: {},
    authRequired: true
  };
};
export const updateFATCADetails = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATEFATCADETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATE_FATCA_DETAILS,
    headers: {},
    authRequired: true
  };
};
export const updateProfileMaster = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATEPROFILEMASTER,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATE_PROFILE_MASTER,
    headers: {},
    authRequired: true
  };
};
export const generateAaadhaarOTP = (payload, service = '') => {
  return {
    url: service + urlTags.GENERATEAADHAAROTP,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_AADHAAR_OTP,
    headers: {},
    authRequired: true
  };
};
export const verifyAadhaarOTP = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYAADHAAROTP,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFY_AADHAAR_OTP,
    headers: {},
    authRequired: true
  };
};

export const getRekycDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETREKYCDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_REKYC_DETAILS,
    headers: {},
    authRequired: true
  };
};

export const getGeoLocation = (payload, service = '') => {
  return {
    url: service + urlTags.GETGEOLOCATION,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_GEOLOCATION,
    headers: {},
    authRequired: true
  };
};
export const saveDeviceDetails = (payload, service = '') => {
  return {
    url: service + urlTags.SAVEDEVICEDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.SAVE_DEVICE_DETAILS,
    headers: {},
    authRequired: true
  };
};
export const updateCurrentAddr = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATECURRENTADDRESS,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATE_CURRENT_ADDRESS,
    headers: {},
    authRequired: true
  };
};
export const getEsignSession = (payload, service = '') => {
  return {
    url: service + urlTags.GETESIGNSESSION,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_ESIGN_SESSION,
    headers: {},
    authRequired: true
  };
};
export const deleteEsignDoc = (payload, service = '') => {
  return {
    url: service + urlTags.DELETEESIGNDOC,
    payload,
    type: Types.POST,
    tag: ApiTag.DELETE_ESIGN_DOCS,
    headers: {},
    authRequired: true
  };
};
export const getSignedDocument = (payload, service = '') => {
  return {
    url: service + urlTags.GETSIGNEDDOCUMENT,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_SIGNED_DOCUMENT,
    headers: {},
    authRequired: true
  };
};
export const proceedVideoKYC = (payload, service = '') => {
  return {
    url: service + urlTags.PROCEEDVKYC,
    payload,
    type: Types.POST,
    tag: ApiTag.PROCEED_VKYC,
    headers: {},
    authRequired: true
  };
};
export const panValidation = (payload, service = '') => {
  return {
    url: service + urlTags.PANVALIDATION,
    payload,
    type: Types.POST,
    tag: ApiTag.PAN_VALIDATION,
    headers: {},
    authRequired: true,
  };
};
// NLI

export const getNSEdetail = (payload, service = '') => {
  return {
    url: service + urlTags.GETNSEDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.GETNSEDETAILS,
    headers: {},
    authRequired: true
  };
};
export const submitFeedbak = (payload, service = '') => {
  return {
    url: service + urlTags.SUBMITFEEDBACKDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.SUBMITFEEDBACKDETAILS,
    headers: {},
    authRequired: true
  };
};
export const submitServiceRequest = (payload, service = '') => {
  return {
    url: service + urlTags.SUBMITSERVICEREQUEST,
    payload,
    type: Types.POST,
    tag: ApiTag.SUBMITSERVICEREQUEST,
    headers: {},
    authRequired: true
  };
};
export const getLoanTracker = (payload, service = '') => {
  return {
    url: service + urlTags.GETLOANTRACKER,
    payload,
    type: Types.POST,
    tag: ApiTag.GETLOANTRACKERTAG,
    headers: {},
    authRequired: true
  };
};
export const overdueAPI = (payload, service = '') => {
  return {
    url: service + urlTags.CALL_ON_CLOSE_OVEDUE,
    payload,
    type: Types.POST,
    tag: ApiTag.CALL_OVERDUE_ONCLOSE,
    headers: {},
    authRequired: true
  };
};
export const getUnclaimedDeposit = (payload, service = '') => {
  return {
    url: service + urlTags.GETUNCLAIMEDDEPOSIT,
    payload,
    type: Types.POST,
    tag: ApiTag.GETUNCLAIMEDDEPOSITTAG,
    headers: {},
    authRequired: true
  };
};
export const getShareHolderData = (payload, service = '') => {
  return {
    url: service + urlTags.GETSHAREHOLDER,
    payload,
    type: Types.POST,
    tag: ApiTag.GETSHAREHOLDERTAG,
    headers: {},
    authRequired: true
  };
};
export const getInvestorUpload = (payload, service = '') => {
  return {
    url: service + urlTags.GETINVESTORUPLOAD,
    payload,
    type: Types.POST,
    tag: ApiTag.GETINVESTORUPLOADTAG,
    headers: {},
    authRequired: true
  };
};
export const getPOS = (payload, service = '') => {
  return {
    url: service + urlTags.GETPOS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETPOSTAG,
    headers: {},
    authRequired: true
  };
};
export const getUnclaimedDividents = (payload, service = '') => {
  return {
    url: service + urlTags.GETUNCLAIMEDIVIDENT,
    payload,
    type: Types.POST,
    tag: ApiTag.GETUNCLAIMEDDIVIDENTTAG,
    headers: {},
    authRequired: true
  };
};
export const getCompliment = (payload, service = '') => {
  return {
    url: service + urlTags.GETCOMPLIMENT,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCOMPLIMENTTAG,
    headers: {},
    authRequired: true
  };
};
export const getGDPR = (payload, service = '') => {
  return {
    url: service + urlTags.GETGDPR,
    payload,
    type: Types.POST,
    tag: ApiTag.GETGDPRTAG,
    headers: {},
    authRequired: true
  };
};
export const getKycDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETkYC,
    payload,
    type: Types.POST,
    tag: ApiTag.GETKYCTAG,
    headers: {},
    authRequired: true
  };
};
export const getQrDetail = (payload, service = '') => {
  return {
    url: service + urlTags.GETQRDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETQRTAG,
    headers: {},
    authRequired: true
  };
};
export const carLoanDash = (payload, service = '') => {
  return {
    url: service + urlTags.CARLOANDASHBOARD,
    payload,
    type: Types.POST,
    tag: ApiTag.CARLOANDASHBOARD_TAG,
    headers: {},
    authRequired: true
  };
};
export const tpuDetails = (payload, service = '') => {
  return {
    url: service + urlTags.TPU,
    payload,
    type: Types.POST,
    tag: ApiTag.TPU_TAG,
    headers: {},
    authRequired: true
  };
};

export const RTGSfundsDetails = (payload, service = '') => {
  return {
    url: service + urlTags.RTGSFUNDS,
    payload,
    type: Types.POST,
    tag: ApiTag.RTGS_TAG,
    headers: {},
    authRequired: true
  };
};
export const neftFunds = (payload, service = '') => {
  return {
    url: service + urlTags.NEFTFUNDS,
    payload,
    type: Types.POST,
    tag: ApiTag.NEFTFUNDS_TAG,
    headers: {},
    authRequired: true
  };
};
export const icicFund = (payload, service = '') => {
  return {
    url: service + urlTags.ICICIFUNDS,
    payload,
    type: Types.POST,
    tag: ApiTag.ICICIFUNDS_TAG,
    headers: {},
    authRequired: true
  }
}
export const GETIANMGES = (payload, service = '') => {
  return {
    url: service + urlTags.GETIANMGES,
    payload,
    type: Types.POST,
    tag: ApiTag.GETIANMGES,
    headers: {},
    authRequired: true,
  };
};
export const getTinMasterDetailsApi = (payload, service = '') => {
  return {
    url: service + urlTags.GETTINMASTERDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETTINMASTERDETAILS,
    headers: {},
    authRequired: true,
  };
};

export const getTinCountryDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETTINCOUNTRYDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETTINCOUNTRYDETAILS,
    headers: {},
    authRequired: true,
  };
};


export const generateSR = (payload, service = '') => {
  return {
    url: service + urlTags.GENERATE_SR,
    payload,
    type: Types.POST,
    tag: ApiTag.GENERATE_SR,
    headers: {},
    authRequired: true,
  };
};

export const getOtpCarLoan = (payload, service = '') => {
  return {
    url: service + urlTags.GETOTP,
    payload,
    type: Types.POST,
    tag: ApiTag.GETOTP,
    headers: {},
    authRequired: true,
  };
};
export const verifyOtpCarLoan = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYOTP_TIO,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFY_OTP_TIO,
    headers: {},
    authRequired: true,
  };
};

export const uploadFilesPebble = (payload, service = '', uploadCallback) => {
  return {
    url: service + urlTags.UPLOAD_FILES_PEBBLE,
    payload,
    type: Types.POST,
    tag: ApiTag.UPLOAD_FILES_PEBBLE,
    headers: { "Content-Type": "multipart/form-data" },
    uploadCallback,
    authRequired: true,
  };
};

export const gridAuthenticationPebble = (payload, service = '') => {
  return {
    url: service + urlTags.GRIDAUTH_PEBBLE,
    payload,
    type: Types.POST,
    tag: ApiTag.GRIDAUTHPEBBLE_TAG,
    headers: {},
    authRequired: true,
  };
};
export const tioUploadFile = (payload, service = '', uploadCallback) => {
  return {
    url: service + urlTags.UPLOADFILES,
    payload,
    type: Types.POST,
    tag: ApiTag.UPLOADFILES,
    headers: { "Content-Type": "multipart/form-data" },
    uploadCallback,
    authRequired: true,
  };
};
export const getDropdownCountry = (payload, service = '') => {
  return {
    url: service + urlTags.GET_DROPDOWN_COUNTRY,
    payload,
    type: Types.POST,
    tag: ApiTag.COUNTRY,
    headers: {},
    authRequired: true,
  };
};
export const getStateCity = (payload, service = '',) => {
  return {
    url: service + urlTags.STATECITYDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.STATECITYDETAIL_TAG,
    headers: {},
    authRequired: true,
  };
};


export const getOtpTio = (payload, service = '') => {
  return {
    url: service + urlTags.GETOTP,
    payload,
    type: Types.POST,
    tag: ApiTag.GETOTP,
    headers: {},
    authRequired: true,
  };
};
export const getBankUserDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETBANKUSERDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETBANKUSERDETAILS,
    headers: {},
    authRequired: true,
  };
};
export const getBranchByPin = (payload, service = '') => {
  return {
    url: service + urlTags.GETBRANCHBYPIN,
    payload,
    type: Types.POST,
    tag: ApiTag.GETBRANCHBYPIN,
    headers: {},
    authRequired: true,
  };
};

// Data governance apis
export const getSourceIdDgov = (payload, service= '')=>{
  return {
    url: service + urlTags.GET_SOURCE_ID,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_SOURCE_TAG,
    headers: {},
    authRequired: true,
  }
}
export const getDecrypetedDataDgov = (payload, service= '')=>{
  return {
    url: service + urlTags.GETDECRYPTEDDATADGOV,
    payload,
    type: Types.POST,
    tag: ApiTag.GETDECRYPTEDDATA_TAG,
    headers: {},
    authRequired: true,
  }
}
export const verifyPanDetailsDgov = (payload, service= '')=>{
  return {
    url: service + urlTags.VERYFYPANDGOV,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYPANDGOV_TAG,
    headers: {},
    authRequired: true,
  }
}
export const generateEmailOtpDgov = (payload, service= '')=>{
  return {
    url: service + urlTags.GENERATAEMAILOTP,
    payload,
    type: Types.POST,
    tag: ApiTag.EMAILOTP__TAG,
    headers: {},
    authRequired: true,
  }
}
export const verifyEmailOtpDgov = (payload, service= '')=>{
  return {
    url: service + urlTags.VERIFYEMAILOTPDOV,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYEMAIL__TAG,
    headers: {},
    authRequired: true,
  }
}
export const gridAuthenticationDgov = (payload, service= '')=>{
  return {
    url: service + urlTags.GRIDAUTHDGOV,
    payload,
    type: Types.POST,
    tag: ApiTag.GRIDAUTH__TAG,
    headers: {},
    authRequired: true,
  }
}
export const submitCustomerdDetDgov = (payload, service= '')=>{
  return {
    url: service + urlTags.SUBMITCUSTOMER,
    payload,
    type: Types.POST,
    tag: ApiTag.SUBMITCUSTOMER_TAG,
    headers: {},
    authRequired: true,
  }
}
export const getAccountsDgov = (payload, service= '')=>{
  return {
    url: service + urlTags.GETACCOUNTS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETACCOUNTS__TAG,
    headers: {},
    authRequired: true,
  }
}
export const updateVariant = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATEVARIANT,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATEVARIANT,
    headers: {},
    authRequired: true,
  };
};

export const pdfGenerator = (payload, service = '',) => {
  return {
    url: service + urlTags.GENERATEPDF,
    payload,
    type: Types.POST,
    tag: ApiTag.GENERATEPDF_TAG,
  };
}
export const getSbNroConvertion = (payload, service = '') => {
  return {
    url: service + urlTags.GETSBNROCONVERSION,
    payload,
    type: Types.POST,
    tag: ApiTag.GETSBNROCONVERSION,
    headers: {},
    authRequired: true,
  };
};
export const verifyOtpTio = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYOTP_TIO,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFY_OTP_TIO,
    headers: {},
    authRequired: true,
  };
};
export const verifyDebitPIn = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYDEBITPIN,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYDEBITPIN,
    headers: {},
    authRequired: true,
  };
};
export const getBankersCertificate = (payload, service = '') => {
  return {
    url: service + urlTags.GETBANKERSCERTIFICATE,
    payload,
    type: Types.POST,
    tag: ApiTag.GETBANKERSCERTIFICATE_TAG,
    headers: {},
    authRequired: true,
  };
};
export const getConversionPDF = (payload, service = '') => {
  return {
    url: service + urlTags.GETCONVERSIONPDF,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCONVERSIONPDF_TAG,
    headers: {},
    authRequired: true,
  };
};
export const getConfirmationPDF = (payload, service = '') => {
  return {
    url: service + urlTags.GETCONVERSIONPDF,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCONFIRMATIONPDF_TAG,
    headers: {},
    authRequired: true,
  };
};
export const gridAuthentication = (payload, service = '') => {
  return {
    url: service + urlTags.GRIDAUTHENTICATION,
    payload,
    type: Types.POST,
    tag: ApiTag.GRIDAUTHENTICATION,
    headers: {},
    authRequired: true,
  };
};
export const getDebitCardNumber = (payload, service = '') => {
  return {
    url: service + urlTags.GETCARDNUMBER,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCARDNUMBER_TAG,
    headers: {},
    authRequired: true,
  };
};
export const updateEStatement = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATEESTATEMENT,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATEESTATEMENT,
    headers: {},
    authRequired: true,
  };
};
export const updateETradeAlerts = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATEETRADEALERTS,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATEETRADEALERTS,
    headers: {},
    authRequired: true,
  };
};
export const updateEmailMob = (payload, service = '') => {
  return {
    url: service + urlTags.UPDATEMAILMOB,
    payload,
    type: Types.POST,
    tag: ApiTag.UPDATEEMAILMOB,
    headers: {},
    authRequired: true,
  };
};
export const getAutoSavedDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETCONVERSIONAUTOSAVE,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCONVERSIONAUTOSAVE,
    headers: {},
    authRequired: true,
  };
};
export const getDownloadFile = (payload, service = '') => {
  return {
    url: service + urlTags.GETCONVERSIONFILE,
    payload,
    type: Types.POST,
    tag: ApiTag.GETCONVERSIONFILE,
    headers: {},
    authRequired: true,
  };
};
export const generateOtp = (payload, service = '') => {
  return {
    url: service + urlTags.GENERATEOTPUPDATE,
    payload,
    type: Types.POST,
    tag: ApiTag.GENERATEOTPUPDATE,
    headers: {},
    authRequired: true,
  };
};
export const verifyOTP = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYYOTPUPDATE,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYYOTPUPDATE,
    headers: {},
    authRequired: true,
  };
};
export const generateOtpDebit = (payload, service = '') => {
  return {
    url: service + urlTags.GENERATEOTPUPDATEDEBIT,
    payload,
    type: Types.POST,
    tag: ApiTag.GENERATEOTPUPDATEDEBIT,
    headers: {},
    authRequired: true,
  };
};
export const verifyOTPDebit = (payload, service = '') => {
  return {
    url: service + urlTags.VERIFYYOTPUPDATEDEBIT,
    payload,
    type: Types.POST,
    tag: ApiTag.VERIFYYOTPUPDATEDEBIT,
    headers: {},
    authRequired: true,
  };
};
export const prepaidCardBlock = (payload, service = '') => {
  return {
    url: service + urlTags.PREPAIDBLOCK,
    payload,
    type: Types.POST,
    tag: ApiTag.PREPAIDBLOCK_TAG,
    headers: {},
    authRequired: true,
  };
};
export const prepaidCardUnblock = (payload, service = '') => {
  return {
    url: service + urlTags.PREPAIDUNBLOCK,
    payload,
    type: Types.POST,
    tag: ApiTag.PREPAIDUNBLOCK_TAG,
    headers: {},
    authRequired: true,
  };
};
export const prepaidPin = (payload, service = '') => {
  return {
    url: service + urlTags.PREPAIDPIN,
    payload,
    type: Types.POST,
    tag: ApiTag.PREPAIDPIN_TAG,
    headers: {},
    authRequired: true,
  };
};
export const prepaidActive = (payload, service = '') => {
  return {
    url: service + urlTags.PREPAIDACTIVE,
    payload,
    type: Types.POST,
    tag: ApiTag.PREPAIDACTIVE_TAG,
    headers: {},
    authRequired: true,
  };
};
export const prepaidActivate = (payload, service = '') => {
  return {
    url: service + urlTags.PREPAIDACTIVATE,
    payload,
    type: Types.POST,
    tag: ApiTag.PREPAIDACTIVATE_TAG,
    headers: {},
    authRequired: true,
  };
};
export const prepaidUserCardDetail = (payload, service = '') => {
  return {
    url: service + urlTags.PREPAIDCARDDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.PREPAIDCARDDETAIL_TAG,
    headers: {},
    authRequired: true,
  };
};
export const prepaidUser = (payload, service = '') => {
  return {
    url: service + urlTags.PREPAIDUSER,
    payload,
    type: Types.POST,
    tag: ApiTag.PREPAIDUSER_TAG,
    headers: {},
    authRequired: true,
  };
};
export const saveSettlmentDetails = (payload, service = '') => {
  return {
    url: service + urlTags.SETTLEMENTREQUEST,
    payload,
    type: Types.POST,
    tag: ApiTag.SETTLEMENT_TAG,
    headers: {},
    authRequired: true,
  };
};
export const prepaidRegister = (payload, service = '') => {
  return {
    url: service + urlTags.PREPAIDREGISTER,
    payload,
    type: Types.POST,
    tag: ApiTag.PREPAIDREGISTER_TAG,
    headers: {},
    authRequired: true,
  };
};
export const prepaidDispatch = (payload, service = '') => {
  return {
    url: service + urlTags.PREPAIDDISPATCH,
    payload,
    type: Types.POST,
    tag: ApiTag.PREPAIDDISPATCH_TAG,
    headers: {},
    authRequired: true,
  };
};
export const getForeCloseDetails = (payload, service = '') => {
  return {
    url: service + urlTags.GETFORECLOSEDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.GETFORECLOSEDETAILS_TAG,
    headers: {},
    authRequired: true,
  }
}
export const getCityStateDetail = (payload, service= '')=>{
  return {
    url: service + urlTags.CITYSTATEDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.CITYSTATE_TAG,
    headers: {},
    authRequired: true,
  }
}
export const visitIndia = (payload, service= '')=>{
  return {
    url: service + urlTags.VISITINDIA,
    payload,
    type: Types.POST,
    tag: ApiTag.VISITINDIA_TAG,
    headers: {},
    authRequired: true,
  }
}
export const auraDetails = (payload, service= '')=>{
  return {
    url: service + urlTags.AURAACCOUTDETAIL,
    payload,
    type: Types.POST,
    tag: ApiTag.AURAACCOUNTDETAIL_TAG,
    headers: {},
    authRequired: true,
  }
}
export const auraSubmit = (payload, service= '')=>{
  return {
    url: service + urlTags.AURASUBMIT,
    payload,
    type: Types.POST,
    tag: ApiTag.AURAACCOUNTSUBMIT_TAG,
    headers: {},
    authRequired: true,
  }
}
export const getDebitDetailsPebble = (payload, service = '') => {
  return {
    url: service + urlTags.GETDEBIT_PEBBLE,
    payload,
    type: Types.POST,
    tag: ApiTag.GETDEBITPEBBLE_TAG,
    headers: {},
    authRequired: true,
  };
};
export const getIncomeTax = (payload, service= '')=>{
  return {
    url: service + urlTags.GET_INCOMETAX,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_INCOMETAX_TAG,
    headers: {},
    authRequired: true,
  }
}

export const m2mValidateUser = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_VALIDATE_USER,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_VALIDATE_USER,
    headers: {},
    authRequired: true,
  };
};

export const m2mGetUserDetails = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_GET_USER_DETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_GET_USER_DETAILS,
    headers: {},
    authRequired: true,
  };
};

export const m2mgenerateOtp = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_GET_M_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_GET_M_OTP,
    headers: {},
    authRequired: true,
  };
};

export const m2mVerifyOtp = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_VERIFY_M_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_VERIFY_M_OTP_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mGridAuthenticationPebble = (payload, service = '/nli') => {
  return {
    url: service + urlTags.GRIDAUTH_PEBBLE,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_GRIDAUTHPEBBLE_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mGetGridCardDebitCardNumberDetails = (
  payload,
  service = '/nli',
) => {
  return {
    url: service + urlTags.GRIDCARDDEBITDETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_GRIDCARDDEBITCARDNUMBER_TAG,
    headers: {},
    authRequired: true,
  };
};

export const m2mGenerateEmailOtp = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_GET_E_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_GET_E_OTP_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mVerifyEmailOtp = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_VERIFY_E_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_VERIFY_E_OTP_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mGenerateAdhaarOtp = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_GET_A_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_GET_A_OTP_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mVerifyAdhaarOtp = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_VERIFY_A_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_VERIFY_A_OTP_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mGetMasterDetails = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_GET_MASTER_LIST,
    payload,
    type: Types.GET,
    tag: ApiTag.M2M_GET_MASTER_LIST_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mValidatePan = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_VALIDATE_PAN,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_VALIDATE_PAN_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mGetGeoLoaction = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_GET_GEOLOCATION,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_GET_GEOLOCATION_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mGetToken = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_GET_TOKEN,
    payload,
    type: Types.GET,
    tag: ApiTag.M2M_GET_TOKEN_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mGetNomineeDetails = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_GET_NOMINEE,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_GET_NOMINEEE_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mGetApplicableProducts = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_GET_APPLICABLE_PRODUCTS,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_GET_APPLICABLE_PRODUCTS_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mSubmit = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_SUBMIT,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_SUBMIT_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mVkyc = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_VKYC,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_VKYC_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mCrmUpdate = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_CRM_UPDATE,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_CRM_UPDATE_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mVkycFromUrl = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_VKYC_FROM_URL,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_VKYC_FROM_URL_TAG,
    headers: {},
    authRequired: true,
  };
};
export const m2mValidateUrl = (payload, service = '/nli/m2m') => {
  return {
    url: service + urlTags.M2M_VALIDATE_URL,
    payload,
    type: Types.POST,
    tag: ApiTag.M2M_VALIDATE_URL_TAG,
    headers: {},
    authRequired: true,
  };
};

// * forex doorstep
export const forexVerifyUser = (payload, service = '/nli/doorstep') => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_VERIFY_USER,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_VERIFY_USER,
    headers: {},
    authRequired: true,
  };
};

export const forexGetCurrency = (payload, service = '/nli') => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_GET_CURRENCY,
    payload,
    type: Types.GET,
    tag: ApiTag.FOREX_DOORSTEP_GET_CURRENCY,
    headers: {},
    authRequired: true,
  };
};
export const forexGetPincodeMaster = (payload, service = '/nli/doorstep') => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_GET_PINCODE_MASTER,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_GET_PINCODE_MASTER,
    headers: {},
    authRequired: true,
  };
};

export const forexGetPincodeDetails = (payload, service = '/nli/doorstep') => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_GET_PINCODE_DETAILS,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_GET_PINCODE_DETAILS,
    headers: {},
    authRequired: true,
  };
};
export const forexGetConversionRates = (payload, service = '/nli/doorstep') => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_GET_CONVERSION_RATES,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_GET_CONVERSION_RATES,
    headers: {},
    authRequired: true,
  };
};

export const forexTotalAmountPayable = (payload, service = '/nli/doorstep') => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_TOTAL_AMOUNT_PAYABLE,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_TOTAL_AMOUNT_PAYABLE,
    headers: {},
    authRequired: true,
  };
};

export const forexPurchaseReqGeneration = (
  payload,
  service = '/nli/doorstep',
) => {
  return {
    url: service + urlTags.FOREX_PURCHASE_REQ_GENERATION,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_PURCHASE_REQ_GENERATION,
    headers: {},
    authRequired: true,
  };
};

export const forexTriggerOtp = (payload, service = '/nli/doorstep') => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_TRIGGER_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_TRIGGER_OTP,
    headers: {},
    authRequired: true,
  };
};

export const forexVerifyOtp = (payload, service = '/nli/doorstep') => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_VERIFY_OTP,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_VERIFY_OTP,
    headers: {},
    authRequired: true,
  };
};

export const forexVerifyGridAuth = (payload, service = NLI) => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_VERIFY_GRID_AUTH,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_VERIFY_GRID_AUTH,
    headers: {},
    authRequired: true,
  };
};

export const forexGetPromoCodes = (payload, service = '/nli/doorstep') => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_GET_PROMO_CODES,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_GET_PROMO_CODES,
    headers: {},
    authRequired: true,
  };
};

export const forexDecrypetedData = (payload, service = '/nli/doorstep',) => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_SSO_DECRYPTED_DATA,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_SSO_DECRYPTED_DATA,
    headers: {},
    authRequired: true,
  };
};

export const esignDBT = (payload, service = '') => {
  return {
    url: service + urlTags.ESIGN_SESSION_DBT,
    payload,
    type: Types.POST,
    tag: ApiTag.ESIGN_SESSION_DBT_TAG,
    headers: {},
    authRequired: true,
  };
};
export const getSignedDocDBT = (payload, service = '') => {
  return {
    url: service + urlTags.ESIGN_UPDATE_DBT,
    payload,
    type: Types.POST,
    tag: ApiTag.ESIGN_UPDATE_DBT_TAG,
    headers: {},
    authRequired: true,
  };
};
export const bankMasterAPI = (payload, service = '') => {
  return {
    url: service + urlTags.GETBANKMASTERLIST,
    payload,
    type: Types.POST,
    tag: ApiTag.GETBANKMASTERLIST_TAG,
    headers: {},
    authRequired: true,
  };
};
export const forexPassportVerification = (
  payload,
  service = '/nli/doorstep',
) => {
  return {
    url: service + urlTags.FOREX_DOORSTEP_PASSPORT_VERIFICATION,
    payload,
    type: Types.POST,
    tag: ApiTag.FOREX_DOORSTEP_PASSPORT_VERIFICATION,
    headers: {},
    authRequired: true,
  };
};

export const rekycNochange = (payload, service = '') => {
  return {
    url: service + urlTags.REKYC_NOCHANGE,
    payload,
    type: Types.POST,
    tag: ApiTag.REKYC_NOCHANGE_TAG,
    headers: {},
    authRequired: true,
  };
};
export const rekycNochangeSR = (payload, service = '') => {
  return {
    url: service + urlTags.REKYC_NOCHANGE_SR,
    payload,
    type: Types.POST,
    tag: ApiTag.REKYC_NOCHANGE_SR_TAG,
    headers: {},
    authRequired: true,
  };
};


export const getDigiLockerUrl = (payload, service = '') => {
  return {
    url: `${service}/${ApiTag.GET_DIGI_LOCKER_URL}`,
    payload,
    type: Types.GET,
    tag: ApiTag.GET_DIGI_LOCKER_URL,
    headers: {},
    authRequired: true,
  };
};
export const getLockerIssuerDocument = (payload, service = '') => {
  return {
    url: `${service}/${ApiTag.GET_DIGI_LOCKER_ISSUER_DOCUMENT}`,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_DIGI_LOCKER_ISSUER_DOCUMENT,
    headers: {},
    authRequired: true,
  };
};
export const getEaadhaarData = (service = DIGILOCKER, payload = {}) => {
  return {
    url: `${service}/${ApiTag.GET_DIGI_LOCKER_EAADHAAR_DATA}`,
    payload,
    type: Types.POST,
    tag: ApiTag.GET_DIGI_LOCKER_EAADHAAR_DATA,
    headers: {},
    authRequired: true,
  };
};

export const getCustDetials = (payload, service = '') => {
  return {
    url: 'https://service.icicibank.com/nli/fetchCustDemogDetail',
    payload,
    type: Types.POST,
    tag: ApiTag.FETCH_CUST_DETAILS_TAG,
    headers: {},
    authRequired: true,
  };
};


export const getBeneficiaryAccountName = (payload, service = '') => {
  return {
    url: 'https://service.icicibank.com/nli/fetchBeneficiaryAccName',
    payload,
    type: Types.POST,
    tag: ApiTag.FETCH_BENEFICIARY_ACC_TAG,
    headers: {},
    authRequired: true,
  };
};